import {
    CLOSE_MODAL,
    OPEN_MODAL
} from './modal-manager.actions';
import {
    ModalManagerState,
    ModalManagerActions
} from './modal-manager.types';

export const INITIAL_MODAL_MANAGER_STATE: ModalManagerState = { currentModal: null };

// TODO needs to make sure that some modals have priority eg:
// if there is a license expire and the current user does is not allowed to continue,
// no other modal should take priority.
export function modalManagerReducer (
    state: ModalManagerState = INITIAL_MODAL_MANAGER_STATE,
    action: ModalManagerActions
) {
    switch(action.type) {
    case OPEN_MODAL: {
        const {
            variant,
            modalProps
        } = action.payload;

        return {
            ...state,
            currentModal: {
                variant,
                modalProps
            }
        };
    }
    case CLOSE_MODAL: {
        return {
            ...state,
            ...INITIAL_MODAL_MANAGER_STATE
        };
    }
    default:
        return state;
    }
}

